import React from "react"

const Spinner = () => {
  return (
    <div className="flex items-center justify-center">
      <h1 className="animate-spin text-6xl">꩜</h1>
    </div>
  )
}

export default Spinner
